import React from "react";

export default function TableChildren({
  children,
  style,
  valuestyle,
  title,
  onClick,
}) {
  return (
    <div
      className={`fs-14 fw-400 d-flex ${style} table-element`}
      title={title}
      onClick={onClick}
    >
      <div className={`${valuestyle}`}>{children}</div>
    </div>
  );
}
